import React from "react";

const PrizesIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_8863_392)">
          <path
            d="M17.9691 5.79041H12.744L14.2538 5.09612C16.0122 4.28809 16.2902 1.87952 14.8817 0.647347C13.4433 -0.61049 11.1754 0.056526 10.6523 1.89898L9.99965 4.19444L9.34741 1.89898C8.82682 0.0674166 6.57965 -0.57934 5.18491 0.582083C3.78438 1.74803 3.8693 4.23404 5.74547 5.09612L7.25575 5.79041H2.03101C1.69948 5.79041 1.43042 6.05947 1.43042 6.391V9.99014C1.43042 10.3221 1.69948 10.5907 2.03101 10.5907H2.64241V19.3994C2.64241 19.7313 2.91148 20 3.243 20C3.54955 20 16.4709 20 16.7571 20C17.0886 20 17.3577 19.7313 17.3577 19.3994V10.5907H17.9691C18.3006 10.5907 18.5697 10.3221 18.5697 9.99014V6.391C18.5697 6.05947 18.3006 5.79041 17.9691 5.79041ZM5.95367 1.50499C6.6699 0.908684 7.90459 1.21523 8.19187 2.2277L9.06513 5.30033L6.24716 4.00505C5.18231 3.51469 5.22848 2.10879 5.95367 1.50499ZM14.0909 1.55144C14.8255 2.19403 14.7407 3.54976 13.7521 4.00505L10.9342 5.30033L11.8074 2.2277C12.0948 1.21603 13.3267 0.8837 14.0909 1.55144ZM2.6316 6.99159H7.6093V9.38955H2.6316V6.99159ZM8.81048 6.99159H11.1896C11.1896 7.2311 11.1896 18.1905 11.1896 18.7988H8.81048C8.81048 18.5365 8.81048 7.09605 8.81048 6.99159ZM17.3685 9.38955H12.3908V6.99159H17.3685V9.38955ZM3.84359 10.6015H7.6093V18.7988H3.84359V10.6015ZM16.1565 18.7988H12.3908V10.6015H16.1565V18.7988Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_8863_392">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default PrizesIcon;
